export default __webpack_public_path__ + "static/media/Atlas-800T-A2.f90ded71.png";